import {Input, Select} from "antd";
import classNames from "classnames";
import {isEmpty} from "lodash";
import get from "lodash/get";
import React, {useEffect, useState} from "react";
import ModuleDom from "./js/module";
import styles from "./matrixSelect.module.less";
import {language} from "@/utils/language";
// pc 端下拉
const MartrixSelect = ({info, answer, changeAnswer}) => {
    const {options = [], id, childs = [], preferences} = info;
    const direction = +get(preferences, "childPrefer.direction", 0);
    const optionForm = +get(preferences, "childPrefer.optionForm", 0);
    const {childPrefer = {}} = preferences;
    let {firstColumnWidth = 50} = childPrefer;
    if (firstColumnWidth === 0) firstColumnWidth = 50;
    const [selectedCodes, setSelectedCodes] = useState({});
    const [showInput, setShowInput] = useState(false);
    const [descriptions, setDescriptions] = useState({});
    const widthStyle = {
        width:
            direction === 0
                ? `${firstColumnWidth}%`
                : 100 /
                (childs || []).filter((item) => +item.moduleOption !== 2).length +
                "%",
    };

    let fixedOne = null;
    if (options.find(o => o?.fixed === 1 && o?.selected === 1)) {
        fixedOne = {
            id: "-1",
            description: (info?.childDescriptions?.[0]) || "",
            selectedOption: options.find(o => o?.fixed === 1 && o?.selected === 1),
            moduleOption: 1,
            fixedOne: true
        };
    }

    const rowData = direction === 0 ? options : childs;
    const colData = direction === 0 ? childs.map((item) => [item]) : [childs];
    const fixedData = fixedOne ? [[fixedOne]] : [];

    useEffect(() => {
        if (isEmpty(selectedCodes)) {
            try {
                const answerObj = answer[info.id] || {};
                const selected = {};
                const inputObj = {};
                let selectedOne = fixedOne ? null : options.find(o => o?.fixed !== 1 && o?.selected === 1);
                childs
                    .filter((c) => c.hide || !c.moduleOption)
                    .forEach(({id, options}, index) => {
                        if (index === 0 && selectedOne) {
                            const findObj = options.find(({id}) => id === selectedOne?.id);
                            if (findObj?.codeValue) {
                                selected[index] = findObj?.codeValue;
                                inputObj[id] = !!selectedOne?.text;
                                changeAnswer({
                                    ...answer[id],
                                    [id]: {
                                        [selectedOne?.id]: null,
                                    },
                                })
                                return
                            }
                        }
                        const optObj = answerObj?.[id] || {};
                        const optId = Object.keys(optObj)?.[0];
                        const findObj = options.find(({id}) => id === optId);
                        if (findObj?.codeValue) {
                            selected[index] = findObj?.codeValue;
                        }
                        inputObj[id] = !!optObj[optId]?.text;
                    });
                options.forEach((item,index) => {
                    if (item?.fixed === 1 && item?.selected !== 1) {
                        selected[-1*(index+1)] = item?.codeValue;
                    }
                })
                setShowInput(inputObj);
                setSelectedCodes(selected);
            } catch (error) {
                console.log(1)
            }
        }
    }, [answer]);

    const renderFixedData = (colCollection, position) => {
        return (<li key={-1}>
            {/* QA */}
            {direction === 0 &&
                (+colCollection[0].moduleOption > 0 ? (
                    <div
                        style={widthStyle}
                        className={classNames(styles.item, "disabled")}
                        dangerouslySetInnerHTML={{
                            __html: colCollection[0].description,
                        }}
                    />
                ) : (
                    <div
                        style={widthStyle}
                        className={styles.item}
                        dangerouslySetInnerHTML={{
                            __html: colCollection[0].description,
                        }}
                    />
                ))}
            {colCollection.map((item, index) => {
                return (
                    <div
                        key={item.id}
                        style={{
                            display: "block",
                            width: `${
                                direction
                                    ? 100 /
                                    (childs || []).filter(
                                        (item) => +item.moduleOption !== 2
                                    ).length
                                    : 100 - firstColumnWidth
                            }%`,
                        }}
                        className={classNames(styles.item, {
                            disabled: +item.moduleOption !== 0,
                        })}
                    >
                        <Select
                            style={{width: "100%"}}
                            value={-1}
                            disabled={true}
                        >
                            <Select.Option
                                style={{}}
                                value={-1}
                                key={-1}
                            >
                                {descriptionRender(item?.selectedOption?.description)}
                            </Select.Option>
                        </Select>
                    </div>
                );
            })}
        </li>)
    }

    return (
        <ul className={styles.wrapper}>
            {/* AQ 表头 */}
            {direction === 1 && (
                <>
                    <li>
                        {fixedData?.[0]?.map((item) => {
                            if (+item.moduleOption !== 2) {
                                return (
                                    <div
                                        key={item.id}
                                        className={classNames(styles.item, {
                                            disabled: +item.moduleOption !== 0,
                                        })}
                                        dangerouslySetInnerHTML={{
                                            __html: item.description
                                                .replace(/<p><\/p>/g, "<br />")
                                                .replace(/\n\n/g, "<br />")
                                                .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                                        }}
                                        style={widthStyle}
                                    />
                                );
                            }
                            return null;
                        })}
                        {rowData.map((item) => {
                            if (+item.moduleOption !== 2) {
                                return (
                                    <div
                                        key={item.id}
                                        className={classNames(styles.item, {
                                            disabled: +item.moduleOption !== 0,
                                        })}
                                        dangerouslySetInnerHTML={{
                                            __html: item.description
                                                .replace(/<p><\/p>/g, "<br />")
                                                .replace(/\n\n/g, "<br />")
                                                .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                                        }}
                                        style={widthStyle}
                                    />
                                );
                            }
                            return null;
                        })}
                    </li>
                </>
            )}

            {direction === 0 && fixedData.map((colCollection, position) => renderFixedData(colCollection, position))}
            {(direction === 1 && fixedOne ? [[fixedOne, ...childs]] : colData).map((colCollection, position) => (
                <li key={position}>
                    {/* QA */}
                    {direction === 0 &&
                        (+colCollection[0].moduleOption > 0 ? (
                            <div
                                style={widthStyle}
                                className={classNames(styles.item, "disabled")}
                                dangerouslySetInnerHTML={{
                                    __html: colCollection[0].description,
                                }}
                            />
                        ) : (
                            <div
                                style={widthStyle}
                                className={styles.item}
                                dangerouslySetInnerHTML={{
                                    __html: colCollection[0].description,
                                }}
                            />
                        ))}
                    {colCollection.filter(item => item?.fixedOne).map((item, index) => (
                        <div
                            key={item.id}
                            style={{
                                display: "block",
                                width: `${
                                    direction
                                        ? 100 /
                                        (childs || []).filter(
                                            (item) => +item.moduleOption !== 2
                                        ).length
                                        : 100 - firstColumnWidth
                                }%`,
                            }}
                            className={classNames(styles.item, {
                                disabled: +item.moduleOption !== 0,
                            })}
                        >
                            <Select
                                style={{width: "100%"}}
                                value={-1}
                                disabled={true}
                            >
                                <Select.Option
                                    style={{}}
                                    value={-1}
                                    key={-1}
                                >
                                    {descriptionRender(item?.selectedOption?.description)}
                                </Select.Option>
                            </Select>
                        </div>
                    ))}
                    {colCollection.filter(item => !item?.fixedOne).map((item, index) => {
                        const answers = answer[id] || answer;
                        const optionId = Object.keys(answers?.[item.id] || {})?.[0];
                        const option = item.options.find((o) => o.id === optionId) || {};
                        const code = option.codeValue;
                        let selectValue = optionId;
                        const inputValue =
                            answers?.[item.id]?.[optionId]?.text ||
                            answers?.[item.id]?.[optionId];
                        for (const [key, value] of Object.entries(selectedCodes)) {
                            if (+key < (direction ? index : position)) {
                                if (code === value && option.optionType !== "1") {
                                    selectValue = "";
                                    try {
                                        delete answer[id][item.id];
                                    } catch {
                                    }
                                }
                            }
                        }
                        return (
                            <div
                                key={item.id}
                                style={{
                                    display: "block",
                                    width: `${
                                        direction
                                            ? 100 /
                                            (childs || []).filter(
                                                (item) => +item.moduleOption !== 2
                                            ).length
                                            : 100 - firstColumnWidth
                                    }%`,
                                }}
                                className={classNames(styles.item, {
                                    disabled: +item.moduleOption !== 0,
                                })}
                            >
                                {+item.moduleOption ? (
                                    <ModuleDom tag="p" moduleOption={item.moduleOption}/>
                                ) : (
                                    <>
                                        <Select
                                            style={{width: "100%"}}
                                            value={selectValue}
                                            onChange={(value) => {
                                                const option = item.options.find((o) => o.id === value);
                                                const code = option.codeValue;
                                                setDescriptions({
                                                    ...descriptions,
                                                    [item.id]: option.description,
                                                });
                                                const obj = Object.assign({}, selectedCodes, {
                                                    [direction ? index : position]: code,
                                                });
                                                setShowInput((old) => ({
                                                    ...old,
                                                    [item.id]: !!option.open,
                                                }));
                                                setSelectedCodes(obj);
                                                changeAnswer({
                                                    ...answer[id],
                                                    [item.id]: {
                                                        [value]: null,
                                                    },
                                                });
                                            }}
                                        >
                                            {(item.options || [])
                                                .filter((o) => !o.hide && !o.moduleOption)
                                                .map((option) => {
                                                    const selected = [];
                                                    if (optionForm === 2) {
                                                        // 之前选中的置灰
                                                        for (const [key, value] of Object.entries(
                                                            selectedCodes
                                                        )) {
                                                            if (+key < (direction ? index : position)) {
                                                                selected.push(value);
                                                            }
                                                        }
                                                    }
                                                    const isSelected = selected.includes(
                                                        option.codeValue
                                                    );
                                                    const isMultiSelect = option.optionType === "1";
                                                    return (
                                                        <Select.Option
                                                            style={{}}
                                                            value={option.id}
                                                            key={option.id}
                                                            disabled={
                                                                (isSelected && !isMultiSelect) || option.disable
                                                            }
                                                        >
                                                            {descriptionRender(option.description)}
                                                        </Select.Option>
                                                    );
                                                })}
                                        </Select>
                                        {(showInput[item.id] || inputValue) && (
                                            <Input
                                                placeholder={language().input_placeholder}
                                                defaultValue={inputValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const _answer = answer[id];
                                                    const qObj = _answer[item.id];
                                                    const optionId = Object.keys(qObj)[0];
                                                    changeAnswer({
                                                        ...answer[id],
                                                        [item.id]: {
                                                            [optionId]: value,
                                                        },
                                                    });
                                                }}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        );
                    })}
                </li>
            ))}
        </ul>
    );
};

export default MartrixSelect;

const descriptionRender = (text) => {
    let html = text
        .replace(/<p><\/p>/g, "<br />")
        .replace(/\n\n/g, "<br />")
        .replace(/\s{2}/g, "&nbsp;&nbsp;");

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: html,
            }}
        />
    );
};


